import type { LinksFunction } from 'react-router'
import { Outlet, useOutletContext } from 'react-router'
import { ContentHeader } from '~/components'

import style from './style.css?url'
import callout from '~/styles/components/callout.css?url'
import spacingUtil from '~/sections/util/spacing.css?url'
import { useRef } from 'react'

// Components (probably need to consolidate these)
import { Flash, styles } from '~/components-v2'
import { Footer } from '~/components-v2/footer/footer'

/**
 * Leveraged by `_content.*` routes
 */
export const links: LinksFunction = () => [
  { rel: 'stylesheet', href: style },
  { rel: 'stylesheet', href: callout },
  { rel: 'stylesheet', href: styles.accordion },
  { rel: 'stylesheet', href: styles.stack },
  { rel: 'stylesheet', href: spacingUtil },
]

export default function () {
  const mainRef = useRef<HTMLDivElement>(null)

  return (
    <>
      <Flash />
      <ContentHeader mainRef={mainRef} />
      <main ref={mainRef} id="main-content">
        <Outlet context={useOutletContext()} />
      </main>
      <Footer />
    </>
  )
}
